import { buildAuthFunctions } from '../helpers.js';

const authFunctions = buildAuthFunctions('lists');

export default {
    archive: authFunctions.delete,
    recover: authFunctions.delete,
    changeOwner: authFunctions.manage,
    ...authFunctions,
};